export default "__VITE_ASSET__C8rAo0gQ__"